import React, { useState } from "react";


const CutFileExtension = (fileName: string) => {

    const removeFileExtension = (filename: string): string => {
        const lastDotIndex = filename.lastIndexOf(".");

        if (lastDotIndex <= 0) return filename;

        return filename.slice(0, lastDotIndex);
    };

    return (
        <>
            <span className="fileExtension">{fileName.split('.').pop()}</span>
            {removeFileExtension(fileName)}
        </>
    )
}


export default CutFileExtension;